
import { Model } from 'backbone';
import listService from 'ListService';

class GridColumnModel extends Model {

    className(){
        return 'GridColumnModel';
    }

    initialize() {
        
    }

    defaults() {
        const defaultFont = listService.accountSettings.DefaultFontSelected || "verdana";
        const def = {};
        def.id = '';
        def.header = '';
        def.index = '0';
        def.width = '171';
        def.type = 'tbl_textInput';
        def.name = '';
        def.obligatoryMessage = '';
        def.textValue = '';
        def.textAlignment = 'left';
        def.alignLeftSelection = 'lightgrey';
        def.alignCenterSelection = 'transparent';
        def.alignRightSelection = 'transparent';
        def.state = '';
        def.isMandatory = '';
        def.obligatoryMessage = '';
        def.footer='';
        def.footerfun = '';
        def.boldSelection = 'transparent';
        def.italicSelection = 'transparent';
        def.textStyle = 'normal !important';
        def.textWeight = 'normal !important';
        def.fontSize = '10';
        def.fontFamily = defaultFont;
        def.backgroundColor = '#FFFFFF';
        def.bgGradientColor = '#FFFFFF';
        def.buttonBackgroundGradientColor = '#CCCCCC';

        def.styleBGColorText = '#FFFFFF';
        def.styleBGColor2Text = '#FFFFFF';
        def.styleBGColorOverText = '#FFFFFF';
        def.styleBGColorOver2Text = '#FFFFFF';
        def.styleBGColorDownText = '#FFFFFF';
        def.styleBGColorDown2Text = '#FFFFFF';
        def.dateValue = '';
        def.dateValueType = 'Specific';
        def.format = 'normal';
        def.dateValueObj = null;
        def.yearsFrom = 1900;
        def.yearsTo = 2100;
        def.styleTextSectionHeader = 'Text';
        def.borderColor = '#000000';
        def.borderColorText = '#000000';
        def.cornerRadius = '';
        def.styleColorText = '#000000';
        def.styleColorOverText = '#000000';
        def.styleColorDownText = '#000000';
        def.styleColor2Text = '#000000';
        def.styleColorOver2Text = '#000000';
        def.styleColorDown2Text = '#000000';
        def.mouseOverTextColor = '#FFFFFF';
        def.textDownColor = '#FFFFFF';
        def.mouseOverColor = '#000000';
        def.backgroundDownColor = '#000000';
        def.bgGradientOverColor = '#000000';
        def.bgGradientDownColor = '#000000';
        def.checked = '';
        def.number = 0;
        def.numericValue = 0;
        def.allowNegative = true;
        def.min = -999999999999;
        def.max = 999999999999;
        def.decimalLength = 2;
        def.showLeadingZero = false;
        def.decimalSeparator = '.';
        def.thousandsSeparator = '';
        def.symbol = '';
        def.addZero = 'unchecked';
        def.paddingAmount = 0;
        def.paddingAlignment = 'Leading';
        def.timeValue = '';
        def.fullhoursClock = 'unchecked';
        def.showSeconds = 'unchecked';
        def.isHidden = false;
        def.buttonBoldSelection = 'transparent';
        def.buttonItalicSelection = 'transparent';
        def.buttonTextStyle = 'normal !important';
        def.buttonTextWeight = 'normal !important';
        def.buttonFontSize = '10';
        def.buttonFontFamily = defaultFont;
        def.buttonStyleColorText = '#000000';
        def.buttonTextColor = '#000000';
        def.fileSize = 2;
        def.captionAttach = 'Attach';
        def.captionDetach = 'Detach';
        def.buttonLeft = 'unchecked';
        def.buttonPosition = 'left';
        def.caption = '';
        def.selectedForm = '';
        def.childFormNewWindow = 'checked';
        def.childFormShowErrorMessages = 'checked';
        def.customFormat = '';
        def.align ='left';
        def.text = '';
        def.textColor = '#000000';
        def.maxChars = 99;
        def.CustomParameters = { parameter: []};
        def.transparentBackground = false;
        def.translateProps = [
            {key:"header", label:"Header"},
            {key:"obligatoryMessage", label:"Mandatory Message"}           
        ];

        return def;
    }

}

export default GridColumnModel;